import React from 'react'
import * as  C from "../componentsM/index"

const AwardOfDiploma = () => {
    return (
        <>

            <C.Hero title={"AWARD OF THE IB DIPLOMA"}
                image={"/hero/12.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>
                    <p>The IB Diploma will be awarded to a candidate provided all the following requirements have been met:</p>


                    <ul className=" my-2">
                        {[
                            "1. CAS requirements have been met.",
                            "2. The candidate’s total points are 24 or more.",
                            "3. There is no “N” awarded for theory of knowledge, the extended essay or for a contributing subject.",
                            "4. There is no grade E awarded for theory of knowledge and/or the extended essay.",
                            "5. There is no grade 1 awarded in a subject/level.",
                            "6. There are no more than two grade 2s awarded (HL or SL).",
                            "7. There are no more than three grade 3s or below awarded (HL or SL).",
                            "8. The candidate has gained 12 points or more on HL subjects (for candidates who register for four HL subjects, the three highest grades count).",
                            "9. The candidate has gained 9 points or more on SL subjects (candidates who register for two SL subjects must gain at least 5 points at SL).",
                            "10. The candidate has not received a penalty for academic misconduct from the Final Award Committee."
                        ]
                            .map((item, index) => (
                                <li key={index} className="text-sm">{item}</li>
                            ))}
                    </ul>


                </div>
            </section>

        </>

    )
}

export default AwardOfDiploma